import {
  FormControl,
  Typography,
  Autocomplete,
  TextField,
  Grid,
  Box,
  Chip,
} from '@mui/material';
import { SelectAutoCompleteOptions } from '../types/selectAutoComplete';

interface InputSelectProps {
  value?: any[] | string;
  name?: string;
  options: SelectAutoCompleteOptions[];
  className?: string;
  error?: any;
  hasError?: boolean;
  disabled?: boolean;
  handleBlur?: (e: any) => void;
  setFieldValue?: any;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
  handleSearch?: any;
  onSelectValue?: any;
  size?: 'small' | 'medium';
}

export const SelectAutoCompleteComponent = ({
  value = '',
  error,
  hasError,
  disabled = false,
  label = '',
  options = [],
  multiple = false,
  handleSearch,
  onSelectValue,
  className,
  handleBlur,
  name,
  size = 'medium',
}: InputSelectProps) => {
  return (
    <Box className={className}>
      <FormControl fullWidth error={hasError} disabled={disabled}>
        <Autocomplete
          size={size}
          disabled={disabled}
          fullWidth={true}
          getOptionLabel={(option: any) => {
            return option?.label ?? option ?? '';
          }}
          options={options}
          multiple={multiple}
          autoComplete
          loading={false}
          includeInputInList
          onBlur={(event) => {
            if (!handleBlur) return;
            handleBlur({
              event,
              target: { name, value },
            });
          }}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                // @ts-ignore - .
                key={index}
                label={option.label}
                {...getTagProps({ index })}
                sx={{ maxWidth: '400px', overflow: 'hidden', height: 20 }}
              />
            ))
          }
          filterOptions={(options) => options}
          loadingText={'Carregando...'}
          filterSelectedOptions
          color={'primary'}
          value={value}
          // @ts-ignore - .
          onInputChange={(event: any, value) => {
            handleSearch(value);
          }}
          // @ts-ignore - .
          onChange={(event: any, newValue: any) => {
            if (onSelectValue) {
              onSelectValue(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField {...params} fullWidth label={label} error={hasError} />
          )}
          // @ts-ignore - .
          renderOption={(props, option: any) => {
            return (
              <li {...props} key={Math.random()}>
                <Grid container alignItems='center'>
                  <Grid item sx={{ display: 'flex', width: 44 }}></Grid>
                  <Grid
                    item
                    sx={{
                      width: 'calc(100% - 44px)',
                      wordWrap: 'break-word',
                    }}
                  >
                    <Box component='span'>{option?.label}</Box>
                  </Grid>
                </Grid>
              </li>
            );
          }}
        />
        {hasError && (
          <Typography variant='body2' color='error' sx={{ pl: 2, pt: 1 }}>
            {error}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};
